import { formatHeaderPhoneNumber, HeaderLogo } from "@highway/design-system";
import { useScreenSize } from "@highway/hwy-design-system";
import { IHeader } from "@highway/mbs-shared";
import { getLicenseLabel } from "@highway/mbs-utils";
import { Link, Stack, Typography, useTheme } from "@mui/material";
import CMAIcon from "../images/CMA-icon.png";

const Header = ({ header }: { header: IHeader }) => {
    const theme = useTheme();
    const { isXS } = useScreenSize();
    return (
        <Stack
            spacing={1}
            alignItems={isXS ? "flex-start" : "center"}
            sx={{ "& > *": { textAlign: isXS ? "left" : "center" } }}
        >
            <Stack
                spacing="inherit"
                alignItems="inherit"
                direction={isXS ? "row-reverse" : "column"}
                justifyContent="space-between"
                width="100%"
            >
                <img
                    src={header.headshotUrl}
                    style={{
                        objectFit: "cover",
                        borderRadius: "50%",
                        height: 80,
                        width: 80,
                    }}
                    alt="Headshot"
                />
                <Stack spacing="inherit">
                    {header.name && (
                        <Typography variant="h6" fontWeight="bold">
                            {header.name}
                        </Typography>
                    )}
                    {header.license.number && (
                        <Typography variant="body1">
                            <Stack>
                                <span>{header.company?.name && `${header.company.name}`}</span>
                                <span>{getLicenseLabel(header.license)}</span>
                            </Stack>
                        </Typography>
                    )}
                </Stack>
            </Stack>
            <div
                style={{ width: "25px", height: "2px", backgroundColor: theme.palette.extendedGreen2.main }}
            />
            <Typography variant="body1">
                <Stack>
                    {header.phoneNumbers?.map((phone, i) => {
                        return <span key={i}>{formatHeaderPhoneNumber(phone)}</span>;
                    })}
                </Stack>
            </Typography>
            {header.email && (
                <Link
                    href={`mailto:${header.email}`}
                    variant="body1"
                    color={theme.palette.primaryPurple.main}
                >
                    {header.email}
                </Link>
            )}
            {header.company?.address && (
                <Typography variant="body2" sx={(theme) => ({ color: theme.palette.extendedGrey1.main })}>
                    {header.company.address && `${header.company.address},`}{" "}
                    {header.company.city && `${header.company.city},`} {header.company.state || ""}{" "}
                    {header.company.zipCode || ""}
                </Typography>
            )}
            {header.hasCMA && (
                <Stack spacing={1} direction={"row"} style={{ marginTop: "0.5rem" }}>
                    <img width={30} src={CMAIcon.src} alt="CMA Logo" />
                    <Typography variant="overline">CERTIFIED MORTGAGE ADVISOR</Typography>
                </Stack>
            )}
            <div>
                <HeaderLogo />
            </div>
        </Stack>
    );
};

export default Header;
